/** @jsxRuntime classic */
/** @jsx jsx */
import { memo } from 'react';
import PropTypes from 'prop-types';
import { jsx, css } from '@emotion/core';
import { white, dark12, brand13 } from "../../../styles/colors";
const getPosition = {
  bottom: `
		overflow-x: auto;
		word-wrap: no-wrap;
	`,
  right: `
		overflow-x: auto;
	`,
  left: `
		overflow-x: auto;
		direction: rtl;
		text-align: left;
	`
};
const scrollbar = ({
  backgroundScroll,
  backgroundThumb,
  backgroundThumbHover,
  children,
  maxWidth,
  maxHeight,
  width,
  height,
  style,
  position,
  custom,
  ...props
}) => {
  const Scrollbar = css`
        position: relative;
        display: block;
        padding: 8px 8px;
        margin-right: 8px;
        max-width: ${maxWidth ? isNaN(maxWidth) ? maxWidth : maxWidth + 'px' : '100%'};
        max-height: ${maxHeight ? isNaN(maxHeight) ? maxHeight : maxHeight + 'px' : '100%'};
        &::-webkit-scrollbar {
            width: ${width ? isNaN(width) ? width : width + 'px' : '8px'};
            height: ${height ? isNaN(height) ? height : height + 'px' : '8px'};
            background-color: ${backgroundScroll};
        }
        &::-webkit-scrollbar-thumb {
            border-radius: 10px;
            mix-blend-mode: normal;
            background-color: ${backgroundThumb};
            background-clip: content-box;
        }
        &::-webkit-scrollbar-thumb:hover {
            border-radius: 10px;
            background-color: ${backgroundThumbHover};
            background-clip: content-box;
        }
        ${/tract/i.test(custom) ? `&::-webkit-scrollbar-track {
						border-radius: 10px;
						mix-blend-mode: normal;
						background: rgba(21, 26, 48, 0.02);
					}` : ''}
        ${getPosition[position]}
    `;
  return jsx("div", {
    css: Scrollbar,
    style: style,
    ...props
  }, children);
};
scrollbar.defaultProps = {
  backgroundScroll: white,
  backgroundThumb: dark12,
  backgroundThumbHover: brand13,
  position: 'right',
  width: 8
};
scrollbar.propTypes = {
  custom: PropTypes.string,
  position: PropTypes.oneOf(['bottom', 'right', 'left']),
  maxHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
  children: PropTypes.node
};
export default /*#__PURE__*/memo(scrollbar);